import { createApiInstance } from './axios-config';
import API_CONFIG from '../../config/apiConfig';

const api = createApiInstance(API_CONFIG.CONVERSATION_SERVICE_URL);

export interface CreateConversationDto {
  title?: string;
  context?: Record<string, any>;
}

export interface SendMessageDto {
  content: string;
  agentId?: string;
  parentMessageId?: string;
}

export class ConversationService {
  async getConversations() {
    const response = await api.get('/api/v1/conversations');
    return response.data.conversations;
  }

  async getConversationWithMessages(conversationId: string) {
    const response = await api.get(`/api/v1/conversations/${conversationId}`);
    return response.data;
  }

  async createConversation(data: CreateConversationDto) {
    const response = await api.post('/api/v1/conversations', data);
    return response.data;
  }

  async updateConversation(conversationId: string, data: { title: string }) {
    const response = await api.patch(`/api/v1/conversations/${conversationId}`, data);
    return response.data;
  }

  async deleteConversation(conversationId: string) {
    const response = await api.delete(`/api/v1/conversations/${conversationId}`);
    return response.data;
  }

  async sendMessage(conversationId: string, data: SendMessageDto) {
    const response = await api.post(`/api/v1/conversations/${conversationId}/messages`, data);
    return response.data;
  }

  async editMessage(messageId: string, content: string) {
    const response = await api.put(`/api/v1/conversations/messages/${messageId}`, { content });
    return response.data;
  }

  async addReaction(messageId: string, emoji: string) {
    const response = await api.post(`/api/v1/conversations/messages/${messageId}/reactions`, { emoji });
    return response.data;
  }

  async removeReaction(messageId: string, emoji: string) {
    await api.delete(`/api/v1/conversations/messages/${messageId}/reactions/${emoji}`);
  }

  async getReactions(messageId: string) {
    const response = await api.get(`/api/v1/conversations/messages/${messageId}/reactions`);
    return response.data.reactions;
  }

  async chat(message: string, agentId: string, conversationId?: string, stream = false) {
    const response = await api.post('/api/v1/chat', { message, agentId, conversationId, stream });
    return response.data;
  }
}